import React from 'react'

import { TabloidCheckIcon } from '../../../../assets/TabloidCheckIcon'
import './share-tabloid-link.scss'

interface FeedbackPopupProps {
  text?: string
}

export const FeedbackPopup = ({
  text = 'Link do folheto copiado',
}: FeedbackPopupProps) => {
  return (
    <div className="feedback-popup-container">
      <TabloidCheckIcon />
      <span className="feedback-popup-text">{text}</span>
    </div>
  )
}
